import { pipe, equals, prop } from 'ramda'

export default function getSchedulingBehavior(resource) {
  if (noDuration(resource)) return 'noDuration'
  else return 'fixedDuration'
}

function noDuration(resource) {
  const propEquals = (p, v) => pipe(prop(p), equals(v))
  const noScheduling = propEquals('AllowsScheduling', false)
  return noScheduling(resource)
}
